import React from 'react';

import { Author } from 'api/cms';
import { Box } from 'components/Box';
import { Byline } from 'components/Byline';
import { BodySmall } from 'components/Text';
import { colors, gutterWidth } from 'theme';

export function AuthorCard({
  fullWidthLayout,
  author,
  homePageUrl,
  postedDate,
  showDate,
}: {
  fullWidthLayout?: boolean;
  author: Author;
  homePageUrl: string;
  postedDate: string;
  showDate: boolean;
}) {
  return (
    <Box
      bg={colors.fog}
      data-qa-id="author-card"
      display="flex"
      flexDirection={['column', null, null, 'row']}
      textAlign={[fullWidthLayout ? 'center' : 'left', null, null, 'left']}
      alignItems={[
        fullWidthLayout ? 'center' : 'flex-start',
        null,
        null,
        'flex-start',
      ]}
      mb="70px"
      p={[gutterWidth / 2, null, null, gutterWidth]}
      borderRadius={[16, null, null, 32]}
    >
      <Byline
        slug={author.slug}
        name={author.name}
        imageHandle={author.image ? author.image.handle : null}
        homePageUrl={homePageUrl}
        postedDate={postedDate}
        showDate={showDate}
      />
      <Box flex="3" mt={[3, null, null, 0]}>
        <BodySmall
          color={colors.battleshipGrey}
          dangerouslySetInnerHTML={{
            __html: author.description,
          }}
          data-qa-id="author-card-description"
        />
      </Box>
    </Box>
  );
}
